/* IssueStatusNode.tsx generated by @compiled/babel-plugin v0.38.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import Lozenge from '@atlaskit/lozenge';
export var IssueStatusNode = function IssueStatusNode(_ref) {
  var status = _ref.status;
  if (!(status !== null && status !== void 0 && status.name) || !(status !== null && status !== void 0 && status.statusCategory.statusCategoryId)) {
    return null;
  }
  var appearance = 'default';
  switch (status.statusCategory.statusCategoryId) {
    case '2':
      appearance = 'default';
      break;
    case '4':
      appearance = 'inprogress';
      break;
    case '3':
      appearance = 'success';
      break;
  }
  return /*#__PURE__*/React.createElement(Lozenge, {
    appearance: appearance,
    isBold: true
  }, status.name.toUpperCase());
};